import axios from 'axios';

const buildFormData = (payload = {}) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    // Allow explicit clearing for optional fields that should be removable.
    if (value === '' && key !== 'notes' && key !== 'buySellAccountId' && key !== 'bac' && key !== 'purchasingBAC') return;
    if (key === 'dafFile') {
      formData.append('dafFile', value);
      return;
    }
    formData.append(key, value);
  });
  return formData;
};

export const getBuySells = async () => {
  const { data } = await axios.get('/api/buy-sells');
  return data;
};

export const createBuySell = async (payload = {}) => {
  const formData = buildFormData(payload);
  const { data } = await axios.post('/api/buy-sells', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const updateBuySell = async ({ id, ...payload }) => {
  if (!id) throw new Error('id is required');
  const formData = buildFormData(payload);
  const { data } = await axios.patch(`/api/buy-sells/${encodeURIComponent(id)}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const promoteBuySell = async (id) => {
  if (!id) throw new Error('id is required');
  const { data } = await axios.post(`/api/buy-sells/${encodeURIComponent(id)}/promote`);
  return data;
};

export const demoteBuySell = async (id) => {
  if (!id) throw new Error('id is required');
  const { data } = await axios.post(`/api/buy-sells/${encodeURIComponent(id)}/demote`);
  return data;
};

export const deleteBuySell = async (id) => {
  if (!id) throw new Error('id is required');
  const { data } = await axios.delete(`/api/buy-sells/${encodeURIComponent(id)}`);
  return data;
};

export const searchBuySellAccounts = async ({ query, limit } = {}) => {
  const { data } = await axios.post('/api/buy-sells/search', { query, limit });
  return data;
};

export const sendBuySellStageEmail = async ({ id, stage }) => {
  if (!id) throw new Error('id is required');
  const { data } = await axios.post(`/api/buy-sells/${encodeURIComponent(id)}/send`, { stage });
  return data;
};
